function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
export var setDropdownsDefaultValue = function setDropdownsDefaultValue(sections, change, values) {
  var selectFields = sections.reduce(function (result, section) {
    if (!Array.isArray(section.form)) return result;
    return [].concat(_toConsumableArray(result), _toConsumableArray(section.form.filter(function (field) {
      return ['select', 'country'].includes(field.type);
    })));
  }, []);

  // Set the default value
  selectFields.forEach(function (field) {
    if (!values || !values[field.name]) {
      change(field.name, Array.isArray(field.options) ? field.options[0] : Object.keys(field.options)[0]);
    }
  });
};